// Libraries
import { Box } from "@material-ui/core";
import { useObserver } from "mobx-react-lite";
import React, { useState } from "react";

// Custom
import { ProductSelectorStyle } from "./ProductSelectorStyle";

import { Email } from "./SubViews/Email";
import { Reset } from "./SubViews/Reset";
//import { Guarantees } from "./SubViews/Guarantees";
import { GutterSystem } from "./SubViews/GutterSystem";
import { Products } from "./SubViews/Products";
//import { Quote } from "./SubViews/Quote";
import { RoofSystem } from "./SubViews/RoofSystem";

import { ProductSelectorViewModel } from "../../ViewModels/ProductSelector/ProductSelectorViewModel";
import { BQSAlertDialog } from "../Primitives/Dialogs/BQSAlertDialog";

interface IProps {
    className?: string;
}

export const ProductSelector: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind

    const productSelectorStyle = ProductSelectorStyle();
    const [viewModel] = useState(() => new ProductSelectorViewModel());

    // #endregion Code Behind

    // #region Render Result

    return useObserver(() => (
        <>
            <Box className={productSelectorStyle.root}>
                <Products viewModel={viewModel.ProductsViewModel} />
                {viewModel.ProductsViewModel.canDisplayRoofSystem && <RoofSystem viewModel={viewModel.RoofSystemViewModel} />}
                {viewModel.ProductsViewModel.canDisplayGutterSystem && <GutterSystem viewModel={viewModel.GutterSystemViewModel} />}
                {/* <Guarantees viewModel={viewModel.GuaranteesViewModel} /> */}
                {/* {viewModel.canDisplayQuoteAndEmail && ( */}
                <React.Fragment>
                    {/*                         <Quote
                            viewModel={viewModel.QuoteViewModel}
                            gutterSystemViewModel={viewModel.GutterSystemViewModel}
                            ReQuoteCallback={viewModel.GuaranteesViewModel.calculateQuote}
                        /> */}
                    <Email sendEmail={viewModel.sendEmail} canExecuteSend={viewModel.canShowSendEmail} productSelectorModel={viewModel.model} />
                </React.Fragment>
                {/*   )} */}
                {viewModel.canDisplayResetSection === true && (
                    <React.Fragment>
                        <Reset></Reset>
                    </React.Fragment>
                )}
            </Box>
            <BQSAlertDialog
                canDisplay={viewModel.errorStore.hasError}
                execute={viewModel.errorStore.Close}
                displayName={viewModel.errorStore.title}
                displayContentLine1={viewModel.errorStore.errorMessage1}
                displayContentLine2={viewModel.errorStore.errorMessage2}
            />
        </>
    ));

    // #endregion Render Result
};
